import React,{ useState, useEffect } from "react";
import { 
    Button,
    Form,
    Radio,
    DatePicker,
    Select,
    Alert,
    Input
} from 'antd';
import axios from 'axios';
import moment from "moment/moment";
import dayjs from "dayjs";

import { 
    CheckCircleOutlined,
    CloseCircleOutlined
} from '@ant-design/icons';

function ActivationDate( { 
        qualifiedAddress,
        cartHasItems,
        currentStep,
        setActivationComponentCompleted,
        setProgressCount,
        serviceAddressComponentCompleted,
        contactInfoComponentCompleted,
        activationComponentCompleted,
        paymentReceived,
        internetServiceInCart,
        isD2C,
        serviceProvider,
        canSelfInstall
    } ) {

    const [leadTime, setLeadTime] = useState(0);
    const [activationMethod, setActivationMethod] = useState(headerVars.installType);
    const [activationTime, setActivationTime] = useState(headerVars.installTime);
    const [currentProvider, setCurrentProvider] = useState(headerVars.currentProvider);
    const [activationDate, setActivationDate] = useState( ( headerVars.installDate != '' ) ? headerVars.installDate : 'Select Date' );
    const [existingAccountNumber, setExistingAccountNumber] = useState(headerVars.existingAccountNumber);
    const [showNextStep, setShowNextStep] = useState( 'none' );
    const [accountNumberValidSuffix, setAccountNumberValidSuffix] = useState(<></>);
    const [existingAccountNumberValid, setExistingAccountNumberValid] = useState(false);

    const siteDomain = headerVars.siteDomain;
    //const vendorType = headerVars.vendor_type;
    const selfInstall = ( canSelfInstall == 'ENABLED' ) ? true : false;
    const [form] = Form.useForm();
    const dateFormat = 'YYYY/MM/DD';
    const disabledDates = ['2024-02-19', '2024-03-29', '2024-04-01', '2024-05-20', '2024-06-01', '2024-09-02', '2024-09-30', '2024-10-14', '2024-11-11', '2024-12-25', '2024-12-26', '2025-01-01'];

    useEffect(() => {
        //console.log("contactInfoComponentCompleted: ", contactInfoComponentCompleted);
        //console.log("serviceAddressComponentCompleted: ", serviceAddressComponentCompleted);
        //console.log("activationComponentCompleted: ", activationComponentCompleted);
        //console.log("cartHasItems: ", cartHasItems);
        //console.log("activationDate: ", activationDate);
        //console.log("activationTime: ", activationTime);
        //console.log("isD2C: ", isD2C);
        //console.log("isD2C: ", isD2C);
        //console.log('serviceProvider:: ', serviceProvider);

        if( cartHasItems &&
            internetServiceInCart &&
            contactInfoComponentCompleted &&
            serviceAddressComponentCompleted ) {
            if( ( serviceProvider == 'Fibre' || serviceProvider == 'Cogeco' ) &&
                activationTime != '' &&
                activationDate != '' ) {
                setActivationComponentCompleted( true );
                setProgressCount(3);
                setShowNextStep( 'none' );
            } else{
                setActivationComponentCompleted( false );
                //setProgressCount(2);
                setShowNextStep( 'block' );
            } 

            if( serviceProvider == 'Fibre' ) {
                calcualteLeadTime( false, 'fibre' );
            }
            
            if( ( serviceProvider != 'Fibre' ) && headerVars.installDate == '' && currentStep >= 2 ) {
                setShowNextStep( 'block' );
            } else if(
                ( 
                    serviceProvider != 'Fibre' && 
                    headerVars.installDate != '' &&
                    headerVars.installType != '' &&
                    currentStep >= 2 &&
                    activationMethod != 'cable-provider-cancel'
                )
                
                ||

                (
                    serviceProvider != 'Fibre' &&
                    headerVars.installDate != '' &&
                    headerVars.installType != '' &&
                    currentStep >= 2 &&
                    activationMethod == 'cable-provider-cancel'&&
                    existingAccountNumber != ''
                )
            ) {
                setShowNextStep( 'none' );
                setActivationComponentCompleted( true );
                setProgressCount(3);
            }
        }
    },[ 
        contactInfoComponentCompleted, 
        serviceAddressComponentCompleted, 
        //activationComponentCompleted,
        cartHasItems, 
        //currentStep
    ])

    const handleChangeActivationDate = () => {
        setShowNextStep( 'block' );
        setProgressCount( 2 );
        setActivationComponentCompleted( false );
    }

    const handleOnNextStepClick = () => {
        setActivationComponentCompleted( true );
        setProgressCount( 3 );
        setShowNextStep( 'none' );

        //console.log( 'activationTime: ', activationMethod );

        let requestUrl = {ajax_url : siteDomain+"/wp-admin/admin-ajax.php"};
        let form_data = new FormData;
        form_data.append('action', 'store_activation_data_in_session');
        form_data.append('activation_date', activationDate );
        form_data.append('activation_time', activationTime );
        form_data.append('activation_type', activationMethod );
        form_data.append('activation_current_provider', currentProvider );
        form_data.append('existing_provider_account_number', existingAccountNumber );

        axios
        .post(requestUrl.ajax_url, form_data)
        .then(function(response){
            //console.log(response);
            document.dispatchEvent(new CustomEvent('cartUpdateState', { detail: '' }));
        })
        .catch(function (error) {
            console.log(error);
        })
        .finally(function () {
            // always executed 
        }); 
    }
    
    const handleActivationTimeSelect = ( value ) => {
        //console.log( "activationTime: ", value );
        setActivationTime( value );
    }

    const onChangeActivationDate = ( date, dateString ) => {
        //console.log("date: ", date);
        //console.log("dateString: ", dateString);
        setActivationDate( dateString );
    }

    const getDisplayOption = () => {
        //console.log( "currentStep: ", currentStep );
        if( 
            cartHasItems && 
            activationComponentCompleted && 
            currentStep >= 2 && 
            !paymentReceived ) {
            return 'block'
        } else {
            return 'none'
        }
    }

    const disabledDate = (current) => {
        let theD = new Date(current);
        let theDFormated = moment(theD).format("YYYY-MM-DD");
        let canDoSaturdays = ( serviceProvider == 'Fibre' ) ? new Date(current).getDay() === 6 : '';
        //console.log("theDFormated: ", theDFormated);

        return (
            //current < moment().endOf('day') ||
            current < moment().add(leadTime, 'days') ||
            new Date(current).getDay() === 0 ||
            canDoSaturdays ||
            disabledDates.find( date => date === theDFormated )
        );
    }

    const handleChangeActivationMethod = ({ target: { value } }) => {
        //console.log('radio1 checked', value);
        setActivationMethod(value);
        form.resetFields();
        calcualteLeadTime( selfInstall, value );
    };

    const getPrettyDateTimeDisplay = () => {

        //console.log( 'activationDate::: ', activationDate );
        if( activationDate != 'Select Date' ) {
            var longDateStr = moment(activationDate, 'Y/M/D').format('dddd MMMM D Y');
            let timeReadable = '';

            if( serviceProvider == 'Fibre' || serviceProvider == 'Cogeco' ) {
                if( activationTime == 'morning' ) {
                    timeReadable = ' - Morning (8:00am - 12:00pm)'
                }
                if( activationTime == 'afternoon' ) {
                    timeReadable = ' - Afternoon (1:00pm - 5:00pm)'
                }
                if( activationTime == 'evening' ) {
                    timeReadable = ' - Evening (5:00pm - 8:00pm)'
                }
            }

            return longDateStr + timeReadable;
        } else {
            return '';
        }
        
    };

    const handleOnAccountNumberInputChange = ( e ) => {
        let currentVal = e.target.value;
        let inputID = e.target.id;
        validateInput( currentVal, inputID );
    }

    const validateInput = ( currentVal, inputId ) => {
        let isValid = true;
        let validationSuffix = <></>;

        switch( inputId ) {
            case 'existing-account-number': 
                if( currentVal.length < 2 ){ 
                    isValid = false;
                }

                validationSuffix = isValid ? <CheckCircleOutlined style={{ color: '#52C41A' }}/> : <CloseCircleOutlined style={{ color: '#ff4545' }}/>;

                let accountNumber = isValid ? currentVal : '';
                setExistingAccountNumberValid( isValid );
                setExistingAccountNumber( accountNumber );
                setAccountNumberValidSuffix( validationSuffix );
                
                // if( !isValid ) { 
                //     setContactInfoComponentCompleted(false);
                //     setProgressCount(0);
                // }
            break;
        }
    }
    
    const getActivationDateMarkup = () => {
        let activationMarkup = [];

        //console.log( "cartHasItems: ", cartHasItems );
        //console.log( "activationComponentCompleted: ", activationComponentCompleted );

        if( cartHasItems && activationComponentCompleted ) {
            activationMarkup.push(
                <div className="activation-date-row">{ getPrettyDateTimeDisplay() }</div>
            );
        } else if( cartHasItems && !activationComponentCompleted && serviceProvider != 'Fibre' && currentStep >= 2 ) {
            activationMarkup.push(<>
                <div className="form-section-header">Transferring services? We may be able to cancel for you.</div>
                <div className="form-column-row cancelation-method-section">
                    <Form.Item
                        //label="Cancelation option"
                        labelCol={{ span: 24 }}
                        name="cancelation-option"
                        style={{ marginBottom:'0', width:'100%' }}
                        rules={[
                            {
                            required: true,
                            message: 'Please select a cancelation option!',
                            },
                        ]}
                    >
                        <Radio.Group 
                            options={
                                [
                                    {
                                        label:'Yes, try to cancel for me',
                                        value:'cable-provider-cancel' 
                                    },
                                    {
                                        label:'No thanks, I will cancel',
                                        value:'cable-provider'
                                    },
                                    {
                                        label:'I dont have service',
                                        value:'no-provider'
                                    }
                                ]
                            } 
                            onChange={ handleChangeActivationMethod } 
                            value={ activationMethod }
                            defaultValue={activationMethod}

                        />
                    </Form.Item>
                </div>
            </>);
        }

        if( cartHasItems && 
            serviceAddressComponentCompleted && 
            contactInfoComponentCompleted && 
            !activationComponentCompleted && 
            activationMethod == 'cable-provider' ) {
            activationMarkup.push(
                <Alert
                    description={<p style={{fontSize:'0.8rem'}}>Transfers from another provider for service at the same address must be scheduled at least 5 business days in advance to qualify for a free transfer.</p>}
                    type="warning"
                    banner
                    showIcon
                    closable
                    style={{ marginBottom:'1rem' }}
                />
            )
        }

        if( cartHasItems && 
            serviceAddressComponentCompleted && 
            contactInfoComponentCompleted && 
            !activationComponentCompleted && 
            activationMethod == 'cable-provider-cancel') {
            activationMarkup.push(
                <Alert
                    description={<><p style={{fontSize:'0.8rem'}}>Transfers from another provider for service at the same address must be scheduled at least 5 business days in advance to qualify for a free transfer.</p>
                    <p style={{fontSize:'0.8rem'}}>Start.ca may be able to cancel for certain providers and unable to cancel for others.</p></>}
                    type="warning"
                    banner
                    showIcon
                    closable
                    style={{ marginBottom:'1rem' }}
                />
            )
        }

        if( cartHasItems && 
            serviceAddressComponentCompleted && 
            contactInfoComponentCompleted && 
            !activationComponentCompleted && 
            ( activationMethod == 'cable-provider-cancel' ) ) {
            activationMarkup.push(
                <div className="form-column-row">
                    <Form.Item
                        label="What is your existing account number"
                        labelCol={{ span: 24 }}
                        name="existing-account-number"
                        style={{marginBottom:'1.5rem', width:'100%'}}
                        rules={[
                            {
                            required: true,
                            message: 'Please input your current provider account number!',
                            },
                        ]}
                    >
                        <Input 
                            id="existing-account-number"
                            suffix={ accountNumberValidSuffix }
                            onChange={handleOnAccountNumberInputChange}
                            defaultValue={ existingAccountNumber }
                        />
                    </Form.Item>
                    <Form.Item
                        label="Who is your current provider?"
                        labelCol={{ span: 24 }}
                        name="current-provider"
                        className='current-provider-dropdown'
                        style={{marginBottom:'1.5rem',width:'100%'}}
                        rules={[
                            {
                            required: true,
                            message: 'Please select your current internet provider!',
                            },
                        ]}
                    >
                        <Select
                            defaultValue={ currentProvider }
                            onChange={ handleCurrentInternetProviderSelect }
                            options={[
                                {
                                value: 'teksavvy',
                                label: 'Teksavvy',
                                },
                                {
                                value: 'execulink',
                                label: 'Execulink',
                                },
                                {
                                value: 'fido',
                                label: 'Fido',
                                },
                                {
                                value: 'rogers',
                                label: 'Rogers',
                                },
                                {
                                value: 'other',
                                label: 'Other',
                                }
                            ]}
                        />
                    </Form.Item>
                </div>
            )
        }
        
        if( cartHasItems && 
            serviceAddressComponentCompleted && 
            contactInfoComponentCompleted && 
            !activationComponentCompleted && 
            ( activationMethod != '' || serviceProvider == 'Fibre' ) ) {
            activationMarkup.push(
                <div className="activation-date-container">
                    <Form.Item
                        label="Date"
                        labelCol={{ span: 24 }}
                        name="activation-date"
                        style={{marginBottom:'0', width:'100%'}}
                        rules={[
                            {
                            required: true,
                            message: 'Please input your desired activation date!',
                            },
                        ]}
                    >
                        <DatePicker 
                            //defaultValue="Select date"
                            disabledDate={disabledDate}
                            style={{width:'100%'}}
                            onChange={onChangeActivationDate}
                        />
                    </Form.Item>
                </div>
            );
        }

        if( cartHasItems && 
            !activationComponentCompleted &&
            serviceAddressComponentCompleted && 
            contactInfoComponentCompleted &&  
            serviceProvider == 'Fibre' ) {
            activationMarkup.push(
                <div className="activation-date-container">
                    <Form.Item
                        label="Time"
                        labelCol={{ span: 24 }}
                        name="activation-time"
                        style={{marginBottom:'0', width:'100%'}}
                        rules={[
                            {
                            required: true,
                            message: 'Please select your desired activation time!',
                            },
                        ]}
                    >
                        <Select
                            defaultValue={ activationTime }
                            onChange={ handleActivationTimeSelect }
                            options={[
                                {
                                value: 'morning',
                                label: 'Morning (8:00am - 12:00pm)',
                                },
                                {
                                value: 'afternoon',
                                label: 'Afternoon (1:00pm - 5:00pm)',
                                }
                            ]}
                        />
                    </Form.Item>
                </div>
            );
        }

        if( cartHasItems && 
            !activationComponentCompleted &&
            serviceAddressComponentCompleted && 
            contactInfoComponentCompleted &&  
            serviceProvider == 'Cogeco' && 
            activationMethod != '' ) {
            activationMarkup.push(
                <div className="activation-date-container time-select">
                    <Form.Item
                        label="Time"
                        labelCol={{ span: 24 }}
                        name="activation-time"
                        style={{marginBottom:'0', width:'100%'}}
                        rules={[
                            {
                            required: true,
                            message: 'Please select your desired activation time!',
                            },
                        ]}
                    >
                        <Select
                            defaultValue={ activationTime }
                            onChange={ handleActivationTimeSelect }
                            options={[
                                {
                                value: 'morning',
                                label: 'Morning (8:00am - 12:00pm)',
                                },
                                {
                                value: 'afternoon',
                                label: 'Afternoon (12:00pm - 4:00pm)',
                                },
                                {
                                value: 'evening',
                                label: 'Evening (4:00pm - 8:00pm)',
                                }
                            ]}
                        />
                    </Form.Item>
                </div>
            );
        }
        
        return (
            <div>
                <Form form={ form }>{ activationMarkup }</Form>
            </div>
        )
    }

    const calcualteLeadTime = ( selfInstall, installOptionSelection ) => {
        let startingDate = new Date();
        let todaysDate = new Date();
        let leadTime = 0;

        if ( selfInstall && installOptionSelection != 'cable-provider' && installOptionSelection != 'cable-provider-cancel') {
            leadTime = 2;
        } else if ( installOptionSelection == 'cable-provider' || installOptionSelection == 'cable-provider-cancel' || installOptionSelection == 'fibre') {
            leadTime = 5;
        } else {
            leadTime = 10;
        }

        let activationAvailableDateTime = startingDate.setDate( startingDate.getDate() + leadTime );
        let activationAvailableDate = new Date(activationAvailableDateTime);
        let sundayMultiplier = accountForSundays( todaysDate, activationAvailableDate );
        
        leadTime += sundayMultiplier; 

        //console.log("sundayMultiplier: ", sundayMultiplier);
        //console.log("leadTime: ", leadTime);
        //console.log("selfInstall: ", selfInstall);
        //console.log("installOptionSelection: ", installOptionSelection);

        setLeadTime( leadTime );
    }

    const accountForSundays = ( fromDate, toDate ) => {
        var weekendDayCount = 0;

        while(fromDate < toDate){
            fromDate.setDate(fromDate.getDate() + 1);
            if(fromDate.getDay() === 0){
                ++weekendDayCount ;
            }
        }

        return weekendDayCount ;
    }

    const handleCurrentInternetProviderSelect = ( value ) => {
        setCurrentProvider( value );
    }

    return ( 
        <div className="configuration-container config-section-container" style={{ display: ( internetServiceInCart ) ? 'block' : 'none' }}>
            <div className="contact-info-folded">
                <hr />
                
                <div className="configuration-header-container">
                    <div className="configuration-header">
                        Activation date
                    </div>
                    
                    <div className="component-update-link" style={{"display": getDisplayOption()}}>
                        <Button type="link" class="change-info-button internet-package-check-availability-button" onClick={ handleChangeActivationDate }>Change</Button>
                    </div>
                </div>
                { getActivationDateMarkup() }
                <Button 
                    onClick={ handleOnNextStepClick } 
                    disabled={ ( 
                        ( activationDate != '' && activationTime != '' && serviceProvider == 'Fibre' ) || 
                        ( activationDate != '' && serviceProvider != 'Fibre' && activationMethod != 'cable-provider-cancel' ) || 
                        ( activationDate != '' && currentProvider != '' && serviceProvider != 'Fibre' && activationMethod == 'cable-provider-cancel' && existingAccountNumber != '' )
                    ) ? false : true }
                    style={ { "margin":'1rem 0', "display": showNextStep } }
                >Next Step</Button>

            </div>
        </div>
    )
}

export default ActivationDate